// extracted by mini-css-extract-plugin
export default {"nav":"navigation_nav__tyH6b"};